/* @flow */

import VMasker from 'vanilla-masker';
import { type Empresa } from '../../empresa/types';
import xhr from '../../utils/xhr';
import getInputPorId from '../../utils/get-input-por-id';
import getSelectPorId from '../../utils/get-select-por-id';

export const editarEstabelecimento = async (empresasId: number, dados: Empresa | any) => {
    await xhr.put(`/empresas/${empresasId}`, dados);
};

const preencherFormEstabelecimento = (empresa: Empresa) => {
    getInputPorId('email-empresa').value = empresa.email;
    getInputPorId('fantasia-empresa').value = empresa.fantasia;
    getInputPorId('razao-social-empresa').value = empresa.razaoSocial;
    getInputPorId('cnpj-empresa').value = String(empresa.cnpj);
    getSelectPorId('empresas-tipos-id-empresa').value = String(empresa.empresasTiposId);
    document.getElementById('empresas-descricao-id-empresa').value = empresa.descricao ? String(empresa.descricao) : '';
    getInputPorId('minimo-entrega-empresa').value = String(empresa.minimoEntrega);
    getInputPorId('maximo-entrega-empresa').value = String(empresa.maximoEntrega);
    getInputPorId('valor-minimo-pedido-empresa').value = String(empresa.valorMinimoPedido);
    getInputPorId('input-representante').value = empresa.representante ? String(empresa.representante) : '';

    const optionFormaDias = getInputPorId('forma-tempo-d');
    const optionFormaHoras = getInputPorId('forma-tempo-h');
    const optionFormaMinutos = getInputPorId('forma-tempo-m');
    const spanTempoMinimo = document.getElementById('span-minimo');
    const spanTempoMaximo = document.getElementById('span-maximo');
    const inputUsaEstoque = getInputPorId('usa-estoque');
    const inputVendasSemPolling = getInputPorId('vendas-sem-polling');
    const classVendasSemPolling = document.querySelector('.vendas-sem-polling');
    const classUsaEstoque = document.querySelector('.usa-estoque');

    if (classVendasSemPolling) {
        classVendasSemPolling.hidden = false;
    }
    if (classUsaEstoque) {
        classUsaEstoque.hidden = false;
    }

    if (empresa.vendasSemPolling === '0') {
        inputVendasSemPolling.checked = false;
        inputVendasSemPolling.value = '0';
    }

    if (empresa.vendasSemPolling === '1') {
        inputVendasSemPolling.checked = true;
        inputVendasSemPolling.value = '1';
    }

    if (empresa.usaEstoque === '0') {
        inputUsaEstoque.checked = false;
        inputUsaEstoque.value = '0';
    }

    if (empresa.usaEstoque === '1') {
        inputUsaEstoque.checked = true;
        inputUsaEstoque.value = '1';
    }

    if (empresa.formaTempo === 'd') {
        getInputPorId('forma-tempo-d').checked = true;
        spanTempoMinimo.innerText = 'dias';
        spanTempoMaximo.innerText = 'dias';
    }
    if (empresa.formaTempo === 'h') {
        getInputPorId('forma-tempo-h').checked = true;
        spanTempoMinimo.innerText = 'horas';
        spanTempoMaximo.innerText = 'horas';
    }
    if (empresa.formaTempo === 'm') {
        getInputPorId('forma-tempo-m').checked = true;
        spanTempoMinimo.innerText = 'minutos';
        spanTempoMaximo.innerText = 'minutos';
    }

    optionFormaDias.onclick = () => {
        spanTempoMinimo.innerText = 'dias';
        spanTempoMaximo.innerText = 'dias';
    };
    optionFormaHoras.onclick = () => {
        spanTempoMinimo.innerText = 'horas';
        spanTempoMaximo.innerText = 'horas';
    };
    optionFormaMinutos.onclick = () => {
        spanTempoMinimo.innerText = 'minutos';
        spanTempoMaximo.innerText = 'minutos';
    };

    VMasker(document.querySelector('#valor-minimo-pedido-empresa')).maskMoney({
        precision: 2,
        separator: ',',
        delimiter: '.',
        unit: 'R$',
        zeroCents: true,
    });

    VMasker(document.querySelector('#cnpj-empresa')).maskPattern('99.999.999/9999-99');
};

export default preencherFormEstabelecimento;
